import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';

import { SELECTED_MEDIA_UPLOAD_ACCEPT } from '../../constants/uploadAccept';

import scss from './SelectedMediaUploadButton.module.scss';

function SelectedMediaUploadButton({ onUpload, disabled }) {
  const { t } = useTranslation('story');
  const inputRef = useRef(null);

  const handleClick = () => {
    inputRef.current?.click();
  };

  const handleChange = (event) => {
    const files = event.target.files;

    if (files?.length) {
      onUpload(files);
    }

    event.target.value = '';
  };

  return (
    <>
      <button type='button' className={scss.button} onClick={handleClick} disabled={disabled}>
        <FileUploadOutlinedIcon className={scss.icon} />
        <span className={scss.label}>{t('upload')}</span>
      </button>
      <input
        ref={inputRef}
        type='file'
        className={scss.input}
        accept={Object.keys(SELECTED_MEDIA_UPLOAD_ACCEPT).join(',')}
        multiple
        onChange={handleChange}
      />
    </>
  );
}

export default SelectedMediaUploadButton;
